import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Tariff, PaymentTypes } from '@app/driver-tariffs/tariff';
import { TariffService } from '@app/driver-tariffs/services/tariff.service';
import { StateService } from '@app/shared';
import { TariffsListComponent } from '@app/driver-tariffs/tariffs-list/tariffs-list.component';

@Component({
  selector: 'app-tariff-page',
  templateUrl: './tariff-page.component.html',
  styleUrls: ['./tariff-page.component.scss']
})
export class TariffPageComponent implements OnInit {
  @ViewChild('titlePage') titlePage: TemplateRef<any>;
  title = 'TARIFFS_TITLE';

  currentTariff: Tariff;
  services = [];
  @ViewChild(TariffsListComponent) tariffList: TariffsListComponent;

  default: Tariff = {
    service_id: this.tariffService.service,
    name: '',
    is_default: false,
    should_penalty_trip_cancel: true,
    penalty_trip_cancel_value: null,
    penalty_trip_cancel_type: PaymentTypes.natural,
    should_penalty_offer_reject: true,
    penalty_offer_reject_value: null,
    penalty_offer_reject_type: PaymentTypes.natural,
    should_penalty_offer_cancel: true,
    penalty_offer_cancel_value: null,
    penalty_offer_cancel_type: PaymentTypes.natural,
    should_penalty_card_payment_trip_cancel: true,
    penalty_card_payment_trip_cancel_value: null,
    penalty_card_payment_trip_cancel_type: PaymentTypes.natural,
    is_commission_enabled: true,
    commission_value: null,
    commission_type: PaymentTypes.natural,
    is_commission_offer_enabled: true,
    commission_offer_value: null,
    commission_offer_type: PaymentTypes.natural,
    use_bonus_value: true,
    bonus_value: null,
    bonus_offer_value: null,
    should_block_ether: true,
    ether_min_balance: null,
    commission_intercity_type: PaymentTypes.natural,
    commission_intercity_value: null,
    is_commission_intercity_enabled: false,
    commission_scale_value_type: 'base',
    commission_scale_type: 'last_week',
    commission_scale_request_type: 'all',
    commission_scale_request_visibility: 'all',
    debt_limit: 0,
    is_commission_hidden_mode_enabled: false,
    commission_hidden_mode_type: PaymentTypes.natural,
    commission_hidden_mode_value: null,
    is_commission_hidden_mode_sending_enabled: false,
    commission_hidden_mode_sending_type: PaymentTypes.natural,
    commission_hidden_mode_sending_value: null,
    is_arrival_bonus_enabled: false,
    arrival_bonus_min_distance: 0,
    arrival_bonus_max_distance: 0,
    arrival_bonus_value: 0,
    arrival_bonus_base_value: 0,
    arrival_bonus_queue_type: 'all'
  };

  constructor(public tariffService: TariffService, private state: StateService) {}

  ngOnInit() {
    this.currentTariff = this.default;
    this.state.getParameter('services').subscribe(res => {
      this.services = res;
      this.tariffService.service = res[0].id;
      this.tariffService.loadTariffs();
    });
  }

  tariffSelected(tariff) {
    this.currentTariff = tariff;
    this.tariffList.selectedTariffId = tariff.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/tariff-page/tariff-page.component.ts